import Logout from './logout-container';
import {ReactRoute} from '../../utils/router-utils';

export default ReactRoute({
    path: '/logout',
    exact: true,
    component: Logout,
    routes: [
    ]
});



// WEBPACK FOOTER //
// ./src/js/routes/logout/index.js